import { Stack, Box, SystemProps } from "@storyofams/react-ui";
import styled from "styled-components";
import { Text } from "../../../components";

const Wrapper = styled(Stack)`
  position: relative;

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 1px;
  }
`;

const Tab = styled(Box).attrs({ as: "button" })`
  position: relative;
  color: ${(p) => p.theme.colors.grey400};

  &:after {
    content: "";
    width: 100%;
    height: 2px;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: background-size 0.25s ease-in-out;
    background: linear-gradient(
      ${(p) => p.theme.colors.grey800},
      ${(p) => p.theme.colors.grey800}
    );
    background-size: 0% 2px;
    background-position: center center;
    background-repeat: no-repeat;
  }

  &.active {
    color: ${(p) => p.theme.colors.grey800};

    &:after {
      background-size: 100% 2px;
    }
  }
`;

interface TabsProps {
  tabs: { label: string; amount: number }[];
  activeTab: number;
  onClick(idx): void;
}

export const Tabs = ({
  activeTab,
  onClick,
  tabs,
  ...props
}: TabsProps & Omit<SystemProps, "flexDirection">) => (
  <Wrapper space={0} maxWidth={400} {...props}>
    {tabs?.map((tab, i) => (
      <Tab
        key={tab.label}
        py={3}
        flex={1}
        display="flex"
        flexShrink={0}
        className={activeTab === i ? "active" : ""}
        color={activeTab === i ? "black" : "grey600"}
        onClick={() => onClick(i)}
        justifyContent="center"
        alignItems="center"
        fontWeight="medium"
      >
        {tab.label}
        <Text
          borderRadius="full"
          bg="grey800"
          color="white"
          ml={1}
          px={0.75}
          py={0.5}
          lineHeight={1}
        >
          {tab.amount}
        </Text>
      </Tab>
    ))}
  </Wrapper>
);
